import React, { Fragment } from "react";

class ModalDinamico extends React.Component {

    state = {
        show: false,
        titulo: "",
        imagenHeaderUrl: "",
        mensaje: "",
        textoBotonIzquierdo: "",
        funcionBotonIzquierdo: null,
        textoBotonDerecho: "",
        funcionBotonDerecho: null,
        hasClose: false,
    }

    componentWillMount() {
        this.setState({
            show: this.props.show,
            titulo: this.props.titulo,
            imagenHeaderUrl: this.props.imagenHeaderUrl,
            mensaje: this.props.mensaje,
            textoBotonIzquierdo: this.props.textoBotonIzquierdo,
            funcionBotonIzquierdo: this.props.funcionBotonIzquierdo,
            textoBotonDerecho: this.props.textoBotonDerecho,
            funcionBotonDerecho: this.props.funcionBotonDerecho,
            hasClose: this.props.hasClose,
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.funcionBotonDerecho !== prevProps.funcionBotonDerecho || this.props.textoBotonDerecho !== prevProps.textoBotonDerecho) {
            this.setState({ funcionBotonDerecho: this.props.funcionBotonDerecho, textoBotonDerecho: this.props.textoBotonDerecho });
        }
        if (this.props.funcionBotonIzquierdo !== prevProps.funcionBotonIzquierdo || this.props.textoBotonIzquierdo !== prevProps.textoBotonIzquierdo) {
            this.setState({ funcionBotonIzquierdo: this.props.funcionBotonIzquierdo, textoBotonIzquierdo: this.props.textoBotonIzquierdo });
        }
        if (this.props.mensaje !== prevProps.mensaje) {
            this.setState({ mensaje: this.props.mensaje });
        }
        if (this.props.titulo !== prevProps.titulo) {
            this.setState({ titulo: this.props.titulo });
        }
        if (this.props.imagenHeaderUrl !== prevProps.imagenHeaderUrl) {
            this.setState({ imagenHeaderUrl: this.props.imagenHeaderUrl });
        }
        if (this.props.hasClose !== prevProps.hasClose) {
            this.setState({ hasClose: this.props.hasClose });
        }
    }

    fncIzq() {
        if (this.state.funcionBotonIzquierdo !== null || this.state.funcionBotonIzquierdo !== undefined) {
            this.state.funcionBotonIzquierdo();
        }
        this.props.closeModalFn(false);
    }
    fncDer() {
        if (this.state.funcionBotonIzquierdo !== null) {
            this.state.funcionBotonDerecho();
        }
        this.props.closeModalFn(false);
    }

    showTypeModal() {
        if (this.state.imagenHeaderUrl !== "" && this.state.titulo !== "Renovación vía nómina") {
            return <img src={this.state.imagenHeaderUrl} className="dmodal-img-header" />;
        }
        return <img src={this.state.imagenHeaderUrl} className="dmodal-img-header-nomina" />;
    }

    showBtnIzq(textoBotonIzquierdo) {
        if (textoBotonIzquierdo !== "") {
            return <div className="col-xs-12 col-md-6">
                <button onClick={() => { this.fncIzq() }} className="dmodal-btn-izq">
                    {textoBotonIzquierdo}</button></div>;
        }
        return '';
    }

    showBtnDer(textoBotonDerecho) {
        if (textoBotonDerecho !== "") {
            return <div className="col-xs-12 col-md-6">
                <button onClick={() => { this.fncDer() }} className="dmodal-btn-der">{textoBotonDerecho}
                </button></div>;
        }
        return '';
    }

    showhasClose(hasClose) {
        if (hasClose !== "") {
            return <button className="dmodal-close-x" onClick={() => { this.props.closeModalFn(false); }}>
                <img src={require("./img/clear_x.svg")} className="x_img" /></button>;
        }
        return '';
    }

    render() {
        const { titulo, mensaje, textoBotonDerecho, textoBotonIzquierdo, hasClose } = this.state;
        const { show } = this.props;
        return (
            <Fragment>
                {show ?
                    <div className="dynamic-modsal-overlay">
                        <div className="dynamic-modal-window">
                            <div className="dynamic-modal-header">
                                <div className="row">
                                    {this.showhasClose(hasClose)}
                                    {this.showTypeModal()}
                                    <h2 className="dmodal-title">{titulo}</h2>
                                </div>
                            </div>
                            <div className="dynamic-modal-body">
                                <div className="row">
                                    {typeof mensaje === "string" ?
                                        <p className="dmodal-body-p">{mensaje}</p>
                                        :
                                        <div className="dmodal-body-comp">{mensaje}</div>
                                    }
                                </div>
                            </div>
                            <div className="dmodal-btns">
                                {this.showBtnIzq(textoBotonIzquierdo)}
                                {this.showBtnDer(textoBotonDerecho)}
                            </div>
                        </div>
                    </div>
                    : ""}
            </Fragment>
        )
    }
}

export default ModalDinamico;


// WEBPACK FOOTER //
// ./src/modalDinamico.cmpt.js